import React, { useState } from 'react';
import { FacebookIcon, InstagramIcon, MailIcon, MessageCircleIcon } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { PrivacyContent } from './PrivacyContent';
import { TermsContent } from './TermsContent';
import { SITE_CONFIG, WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl } from '../utils/analytics';
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
const quickLinks = [{
  label: 'Ejemplos',
  href: '#ejemplos'
}, {
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: 'Cómo funciona',
  href: '#proceso'
}, {
  label: 'Precio',
  href: '#precio'
}, {
  label: 'Preguntas',
  href: '#preguntas'
}];
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="border-t border-white/10 bg-[#0c0c1c] py-14" data-id="element-918">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-919">
          <div className="grid gap-10 border-b border-white/10 pb-10 md:grid-cols-[1.35fr_.65fr_.8fr]" data-id="element-920">
            <div data-id="element-921">
              <a href="#" className="inline-flex" data-id="element-922">
                <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className="h-14 w-auto object-contain" data-id="element-923" />
              </a>
              <p className="mt-5 max-w-sm leading-relaxed text-[#a9a9ba]" data-id="element-924">
                Diseñamos páginas profesionales para negocios que quieren
                presentar mejor sus productos, servicios y experiencia.
              </p>
              <div className="mt-6 flex gap-3" data-id="element-925">
                <a href={SITE_CONFIG.social.instagram[0]} target="_blank" rel="noopener noreferrer" aria-label="Instagram de Estrategias Digitales A-Z" className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 text-[#c9c9d5] transition-colors hover:border-[#a738f4] hover:text-white" data-id="element-926">
                  <InstagramIcon className="h-5 w-5" data-id="element-927" />
                </a>
                <a href={SITE_CONFIG.social.facebook[0]} target="_blank" rel="noopener noreferrer" aria-label="Facebook de Estrategias Digitales A-Z" className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 text-[#c9c9d5] transition-colors hover:border-[#a738f4] hover:text-white" data-id="element-928">
                  <FacebookIcon className="h-5 w-5" data-id="element-929" />
                </a>
              </div>
            </div>

            <div data-id="element-930">
              <h2 className="text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-931">
                Navegación
              </h2>
              <ul className="mt-5 space-y-3" data-id="element-932">
                {quickLinks.map(link => <li key={link.href} data-id="element-933">
                    <a href={link.href} className="text-sm text-[#a9a9ba] transition-colors hover:text-[#20d6e8]" data-id="element-934">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-935">
              <h2 className="text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-936">
                Contacto
              </h2>
              <div className="mt-5 space-y-4 text-sm text-[#a9a9ba]" data-id="element-937">
                <a href={createWhatsAppUrl(WHATSAPP_MESSAGES.general)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-white" data-id="element-938">
                  <MessageCircleIcon className="h-4 w-4 text-[#25d366]" data-id="element-939" />
                  +506 8531-6690
                </a>
                <a href={`mailto:${SITE_CONFIG.email}`} className="flex items-center gap-3 transition-colors hover:text-white" data-id="element-940">
                  <MailIcon className="h-4 w-4 text-[#20d6e8]" data-id="element-941" />
                  {SITE_CONFIG.email}
                </a>
                <p data-id="element-942">{SITE_CONFIG.location}</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4 pt-7 text-sm text-[#818192] md:flex-row md:items-center md:justify-between" data-id="element-943">
            <p data-id="element-944">
              © {currentYear} Estrategias Digitales A-Z. Todos los derechos
              reservados.
            </p>
            <div className="flex gap-5" data-id="element-945">
              <button type="button" onClick={() => setActiveModal('terms')} className="transition-colors hover:text-white" data-id="element-946">
                Términos del servicio
              </button>
              <button type="button" onClick={() => setActiveModal('privacy')} className="transition-colors hover:text-white" data-id="element-947">
                Política de privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos del servicio" data-id="element-948">
        <TermsContent data-id="element-949" />
      </LegalModal>
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de privacidad" data-id="element-950">
        <PrivacyContent data-id="element-951" />
      </LegalModal>
    </>;
}